import { ProductCodesEnum } from '../..'

export type BaseRequest = {
  callerId: ProductCodesEnum
}
